import { Component, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { RoleService } from 'src/app/services/role/role.service';
import { RoleModalService } from 'src/app/services/role-modal.service';
declare var bootstrap: any;

@Component({
  selector: 'app-cm-roles-list',
  templateUrl: './cm-roles-list.component.html',
  styleUrls: ['./cm-roles-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CmRolesListComponent extends DestructorComponent implements AfterViewInit {

  data:any;

  constructor(
    private _primaryService:RoleService,
    private _roleModalService: RoleModalService
  ){
    super();
  }

  ngAfterViewInit(): void {

  }

  ngOnInit(){
    this.getData();
  }


  getData(){
    this.subscriptions.push(this._primaryService.GetData("1").subscribe((res:any)=>{
      this.data = res.data.data;
    }))
  }

  getPermissionDescription(permissions: any): string[] {
    const descriptions: string[] = [];

    if (!permissions) {
      return descriptions;
    }

    Object.keys(permissions).forEach(moduleKey => {
      const module = permissions[moduleKey];
      if (!module || !module.name) {
        return;
      }

      const permissionsList: string[] = [];

      if (module.view === true) {
        permissionsList.push('Can View');
      }
      if (module.add === true) {
        permissionsList.push('Can Add');
      }
      if (module.edit === true) {
        permissionsList.push('Can Edit');
      }

      // Only add to descriptions if at least one permission is true
      if (permissionsList.length > 0) {
        descriptions.push(`${module.name} : ${permissionsList.join(', ')}`);
      }
    });

    return descriptions;
  }

  // Method to handle edit role button click
  editRole(role: any) {
    // Set the selected role in the service
    this._roleModalService.setSelectedRole(role);

    // Open the modal
    const modalElement = document.getElementById('kt_modal_update_role');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }

  // Method to handle role updated event
  onRoleUpdated() {
    console.log('Role updated, refreshing list...');
    this.getData(); // Refresh the roles list
  }
}
